module.exports = "/images/loja2.png?b91e8a638e8c5a960f8acf1396527249";